export default require('../../../api_server/project_id_to_template.json');
